import axiosInstance from '../../lib/axios';

// Admin tree, not /taxonomy/tree/ - the public one hides drafts and empty
// nodes, so a node would be invisible in the tool that just created it.
export const fetchTree = async (scope = 'session_audio') => {
  const response = await axiosInstance.get('/admin/taxonomy/tree/', { params: { scope } });
  return response.data;
};

export const fetchAttributes = async (scope = 'session_audio') => {
  const response = await axiosInstance.get('/admin/taxonomy/attributes/', { params: { scope } });
  return response.data;
};

export const createAttribute = async (data) => {
  const response = await axiosInstance.post('/admin/taxonomy/attributes/', data);
  return response.data;
};

// key and input_type are immutable server-side: every audio already tagged
// stores the key, and its value only makes sense under the original type.
export const updateAttribute = async (id, data) => {
  const response = await axiosInstance.patch(`/admin/taxonomy/attributes/${id}/`, data);
  return response.data;
};

export const fetchNodeAudios = async (nodeId, limit = 20) => {
  const response = await axiosInstance.get('/audios/', { params: { node: nodeId, limit } });
  return response.data;
};

export const createNode = async (data) => {
  const response = await axiosInstance.post('/admin/taxonomy/nodes/', data);
  return response.data;
};

export const updateNode = async (id, data) => {
  const response = await axiosInstance.put(`/admin/taxonomy/nodes/${id}/`, data);
  return response.data;
};

export const deleteNode = async (id) => {
  const response = await axiosInstance.delete(`/admin/taxonomy/nodes/${id}/`);
  return response.data;
};

export const reorderNode = async (id, afterId) => {
  const response = await axiosInstance.post(`/admin/taxonomy/nodes/${id}/reorder/`, {
    after_id: afterId ?? null,
  });
  return response.data;
};

export const moveNode = async (id, parentId) => {
  const response = await axiosInstance.post(`/admin/taxonomy/nodes/${id}/move/`, {
    parent_id: parentId ?? null,
  });
  return response.data;
};

export const updateAudioTaxonomy = async (id, data) => {
  const response = await axiosInstance.put(`/audios/${id}/taxonomy/`, data);
  return response.data;
};
